/* eslint-disable no-loop-func */
/* eslint-disable */
<template>
  <div class="order-wrapper payment-wrapper" v-bind:class="{ 'is-active': openSlideleft }">
    <portal target-el="#filter">
      <PrimaryFilter
        :searchText="$t('SEARCH')"
        isPayment="true"
        :selectedCategory="selectedCategory"
        :menuOptions="$checkMenuOptions(Menu)"
        :buttonsList="paymentsButtonsList"
        :searchParameters="paymentSearchParameters"
        :preSearchedParams="searchedParams"
        :enableSearchPopup="enableSearchPopup"
        :queryParams="selectedIds"
        @searchByParameter="searchByParameter"
        @downloadExcel="downloadExcel"
        @addToInvoice="openInvoicePanel"/>
    </portal>
    <div>
      <div class="flex-container page-filter">
        <div class="flex-item">
          <FilterWrapper
            :values="filterTags"
            @openSliderLeft="openSlideleft = !openSlideleft">
          </FilterWrapper>
        </div>

        <div class="flex-item f-right">
          <div class="selectedcount">
            <div>
              <span class="selectedcount-number">{{selected.length}}</span>
              <span class="selectedcount-name">Indent selected</span>
            </div>
            <div class="selectedcount-value">
              <svgicon name="rupee" class="icon" width="12" height="12" :original="true" />
              {{$getIndianFormat(selectedSum)}}
            </div>
          </div>
        </div>
      </div>
      <div class="slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
        <div class="slideleft_content">
          <div class="content">
            <div class="cardpanel alertoption"
              v-infinite-scroll="loadData"
              infinite-scroll-disabled="loadCheck"
              infinite-scroll-immediate-check="false"
              infinite-scroll-throttle-delay="400"
              infinite-scroll-distance="10">
              <Header
                :headers="getPaymentHeader"
                :showSelectAllOption="isSelectedIndents"
                :noCheckbox="!isSelectedIndents"
                :checkboxSpace="true"
                :currentClientConfig="currentClientConfig"
                @clearAll="clearSelected"
                @selectAll="selectAllMethod" />
              <div v-if="isLoading" class="paymentloader"></div>
              <div v-else-if="payments.length === 0" class="emptydiv">
                <div class="paymentempty"></div>
                <div class="emptytext">Enjoy your day, no indents delivered!</div>
                <div class="emptytext txtopacity">गाड़ी नहीं पहुंची क्या ?</div>
              </div>
              <div v-else>
                <PaymentRow v-for="(payment,index) in payments"
                  :sectionHeader="getPaymentHeader"
                  :isMultiDrop="isMultiDrop"
                  :payment="payment"
                  :parentPayment="getParentIndent(payment)"
                  :deliveryType="deliveryType"
                  :type="type"
                  :truck_type="truck_type"
                  :movement="movement"
                  :poNumber="poNumber"
                  :paymentDestinationDepot="paymentDestinationDepot"
                  :indentDate="indentDate"
                  :indentStatus="indentStatus"
                  :isSpecialRebateGateIndent="isSpecialRebateGateIndent"
                  :billToPartyId="billToPartyId"
                  :taxType="taxType"
                  :state="state"
                  :key="payment.id"
                  :selected="selected"
                  :blockingDueToAgedInvoice="blockingDueToAgedInvoice"
                  :blockingDueToAgedPayments="blockingDueToAgedPayments"
                  :paymentAgeWindow="paymentAgeWindow"
                  :disabledPayments="disabledPayments"
                  :disabledPaymentsWithDiffLE="disabledPaymentsWithDiffLE"
                  @select="handleSelected"
                  @markDisabled="markDisabled"
                  @updateIndent="updateIndent(index)"/>
              </div>
            </div>
          </div>
        </div>
        <div class="slideleft_menu">
          <SecFilter
            v-if="filterConstant.length > 0"
            :selectedFilters="filterConstant"
            @search="search"
            @updateOption="updateLegalEntity"
            @reset="resetApply"
            @clearDate="clearDate"/>
        </div>
        <div class="sidenavright" :class="{ isOpen: isOpenUpdate }">
          <Update
            v-if="isOpenUpdate"
            :indentDetails="selectedIndentDetail"
            :chargeComments="chargeComments"
            :isFirstIndent="isFirstIndex"
            :isLastIndent="isLastIndent"
            @setGA="setGA"
            @close="isOpenUpdate = false"
            @nextIndent="nextIndent"
            @previousIndent="previousIndent"
            @updateIndentDetails="updateIndentDetails"
            @addIndentDetails="addIndentDetails"
            @removeIndentDetails="removeIndentDetails"
            @updatePaymentDetails="updatePaymentDetails" />
        </div>
      </div>
    </div>
    <div class="slideleft_drawer">
      <div class="slideleft_content">
        <div class="content pt-40">
          <Drawer :visible.sync="showInvoicePanel" direction="rtl" size="520px" :modal="true" :withHeader="false"
            class="default-drawer" :append-to-body="true" :destroy-on-close="true">
            <Link :underline="false" class="nav-close" @click="showInvoicePanel = false">
            <svgicon name="cancelwhite" width="12" height="12" :original="true" />
            </Link>
            <InvoiceSelectionPanel :filterParams="invoiceFilterParams" :selectedPaymentIds="selectedPaymentIds"
              :selectedMovement="movement"
              :selectedDeliveryType="deliveryType"
              :selectedPaymentType="type"
              :selectedTruckType="truck_type"
              :selectedBillToParty="billToPartyId"
              @close="showInvoicePanel = false"
              @addToInvoice="confirmAddPaymentToInvoice" />
          </Drawer>
        </div>
      </div>
    </div>
    <Dialog title="Add Payment Status" :visible.sync="addProgressDialog" width="35%" :close-on-click-modal="false"
      :show-close="addProgressStatus === 'completed' || addProgressStatus === 'failed'"
      class="infodialog topmargin_n centerdialogblock">
      <ProgressSteps :steps="addProgressSteps" :status="addProgressStatus" :step="addProgressStep"
        :error-message="addProgressError" />
    </Dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import { getDateDiff } from '@/lib/Date';
import SecFilter from '@/components/pay-v2/actions/SecFilter';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import Header from '@common/components/Header';
import AppConstant from '@/constants/app';
import { MultiMonthPaymentConstants, getPaymentTypes, utilizationStatus, movementMapLower, movementMapLowerForConfig } from 'pando-constants';

import FilterWrapper from '@common/components/FilterWrapperV2';
import { getTransporterCharges } from '@common/lib/payments';
import {
  PaymentHeader,
  deliveryTypes,
  dateFilterTypes,
  Menu,
  paymentsButtons,
  taxTypes,
  indentFilters,
  statusFilters,
  enabledPayInDispatchStatusFilters,
  paymentSearchParameters,
  filters,
  defaultLEFilter,
  ADD_PAYMENT_STEPS } from '@/constants/payments';

import { uniqBy } from 'lodash';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import PaymentRow from '../../pay-v2/payments/PaymentRow';
import Update from '../../pay-v2/payments/Update';
import InvoiceSelectionPanel from '../../pay-v2/payments/InvoiceSelectionPanel';
import ProgressSteps from '@/components/common/ProgressSteps';
import JobStatusPoller from '@/utils/jobStatusPoller';


export default {
  mixins: [SecFilterMixin, JobStatusPoller],
  components: {
    Header,
    PaymentRow,
    SecFilter,
    FilterWrapper,
    PrimaryFilter,
    Update,
    InvoiceSelectionPanel,
    ProgressSteps,
  },
  data() {
    return {
      PaymentHeader,
      openSlideleft: false,
      deliveryTypes,
      taxTypes,
      dateFilterTypes,
      indentFilters,
      statusFilters,
      enabledPayInDispatchStatusFilters,
      paymentsButtons,
      deliveryType: null,
      type: null,
      movement: null,
      isMultiDrop: '',
      truck_type: null,
      isSpecialRebateGateIndent: null,
      billToPartyId: null,
      taxType: '',
      state: '',
      selected: [],
      disabledPayments: [],
      disabledPaymentsWithDiffLE: [],
      defaultValues: {},
      Menu,
      isOpenUpdate: false,
      loadCheck: true,
      index: 0,
      selectedIndentDetail: null,
      searchedParams: {},
      orderId: null,
      centerDialogVisible: false,
      filterConstant: [],
      filters,
      blockingDueToAgedInvoice: false,
      blockingDueToAgedPayments: false,
      messageData: null,
      paymentSearchParameters,
      enableSearchPopup: true,
      poNumber: null,
      indentDate: null,
      indentStatus: null,
      chargeComments: {},
      excludedAssociatedPayments: [],
      defaultLEFilter,
      legalEntityFilters: [],
      pandoLegalEntityFilters: [],
      movementMapLowerForConfig,
      showInvoicePanel: false,
      addProgressDialog: false,
      addProgressStatus: null,
      addProgressStep: 0,
      addProgressError: null,
      addProgressSteps: ADD_PAYMENT_STEPS,
    };
  },
  computed: {
    ...mapGetters({
      payments: 'paymentsV2/list',
      clients: 'app/clients',
      depots: 'app/depots',
      isLoading: 'paymentsV2/isLoading',
      hasEmpty: 'paymentsV2/hasEmpty',
      filter: 'paymentsV2/filter',
      currentClientConfig: 'app/currentClientConfig',
      otherDepots: 'app/getOtherDepots',
    }),
    customLegalEntityAllowed() {
      return this.$hasFeature('primary_legal_entity');
    },
    isLegalEntityBasedOnBillToParty() {
      return this.$hasFeature('legal_entity_based_on_bill_to_party');
    },
    filteredStatusFilters() {
      return this.statusFilters.filter(status =>
        !status.feature || this.$hasFeature(status.feature)
      );
    },
    getPaymentHeader() {
      return this.PaymentHeader.filter(header => !header.hide_header_config
        || (header.hide_header_config && this.currentClientConfig.payment_settings
          && !this.currentClientConfig.payment_settings[header.hide_header_config]));
    },
    selectedSum() {
      return this.selected.reduce((accumulator, presentValue) => {
        let result = accumulator;
        result += parseFloat(presentValue.indent_total_charge);
        return result;
      }, 0);
    },
    paymentAgeWindow() {
      return (this.currentClientConfig && this.currentClientConfig.payment_settings
        && this.currentClientConfig.payment_settings.max_age_ready_for_billing) || 0;
    },
    showLegalEntity() {
      return (this.currentClientConfig && this.currentClientConfig.legal_entity_level === 'GATE') || this.$hasFeature('show_legal_entity_filter');
    },
    isSelectedIndents() {
      return this.selected.length > 0;
    },
    selectedCategory() {
      return this.Menu.find(menu => menu.id === 'payments');
    },
    selectedIds() {
      return this.selected.map(obj => obj.id).join(',');
    },
    isFirstIndex() {
      return this.index === 0;
    },
    isLastIndent() {
      return this.index === this.payments.length - 1;
    },
    selectedPaymentIds() {
      return this.selected.map(p => p.id);
    },
    invoiceFilterParams() {
      const filter = this.constructFilterPayload();
      const params = {};
      if (filter.client_id) params.client_id = filter.client_id;
      if (filter.depot_id) params.depot_id = filter.depot_id;
      if (filter.legal_entity) params.legal_entity = filter.legal_entity;
      if (filter.client_legal_entity) params.client_legal_entity = filter.client_legal_entity;
      return params;
    },
    paymentsButtonsList() {
      const buttonList = this.paymentsButtons;
      const buttonIndex = this.paymentsButtons.findIndex(button => button.name === 'Download');
      buttonList[buttonIndex].disabled = !this.selectedIds;
      const addToInvoiceIndex = buttonList.findIndex(button => button.name === 'Add to Invoice');
      if (addToInvoiceIndex > -1 && this.$hasFeature('payment_update_to_invoice')) {
        buttonList[addToInvoiceIndex].show = this.isSelectedIndents;
      }
      return buttonList;
    },
    enabledPayments() {
      const enabledPays = [];
      const lrAttachmentsConfig = this.currentClientConfig.payment_settings &&
        this.currentClientConfig.payment_settings.lr_attachment_required;
      for (let payIndex = 0; payIndex < this.payments.length; payIndex += 1) {
        const payment = this.payments[payIndex];
        let forcedisable = false;
        if (this.blockingDueToAgedInvoice) {
          forcedisable = true;
        }
        const deliveryDate = payment.delivered_date;
        payment.age = getDateDiff(moment(), deliveryDate).toString();
        payment.deliveryDate = moment(deliveryDate).format('DD MMM YYYY');
        const disableRow = this.blockingDueToAgedPayments && !(payment.age >= this.paymentAgeWindow);
        if (disableRow) {
          forcedisable = true;
        }
        if (AppConstant.OrderType.OPEN === payment.order_type) {
          const isFreightRatePresent = payment.consignee_data.some(
            consignee => getTransporterCharges(consignee.charges)
              && getTransporterCharges(consignee.charges).contract_charge,
          );
          if (!isFreightRatePresent) {
            forcedisable = true;
          }
        }
        if (payment.status !== this.$statusUtil.getStatusId('cancelled')) {
          if (!(payment.all_physical_documents_available &&
          ((lrAttachmentsConfig && lrAttachmentsConfig[movementMapLower[payment.movement]]) ? payment.lr_attachment_available :
            true))) {
            forcedisable = true;
          }
        }
        if (!forcedisable && this.type === getPaymentTypes().DEDICATED_TRUCK_WITH_INDENT_PAYMENT
          && this.type && this.truck_type
          && !(this.type === payment.type && this.truck_type === payment.truck_type)) {
          forcedisable = true;
        } else if (!forcedisable && this.type && !(this.type === payment.type)) {
          forcedisable = true;
        }
        if (!forcedisable && this.deliveryType && this.deliveryType !== payment.delivery_type) {
          forcedisable = true;
        }
        if (!forcedisable && this.isSpecialRebateGateIndent && (this.isSpecialRebateGateIndent !== payment.is_special_rebate_gate_indent)) {
          forcedisable = true;
        }
        const restrictedMovements = Object.keys((this.currentClientConfig.payment_settings &&
          this.currentClientConfig.payment_settings.max_indents_for_invoice) || {});
        const currPaymentMovement = this.currentMovement(payment);
        // use payment's own movement as fallback when no indent is selected yet (this.movement is null)
        const effectiveMovement = this.movement || currPaymentMovement;
        if (restrictedMovements.includes(this.movementMapLowerForConfig[effectiveMovement])
          || restrictedMovements.includes(this.movementMapLowerForConfig[currPaymentMovement])) {
          if (this.movement && this.movement !== currPaymentMovement) {
            forcedisable = true;
          }
          const count = this.currentClientConfig.payment_settings
            .max_indents_for_invoice[this.movementMapLowerForConfig[effectiveMovement]];
          const isAlreadySelected = this.selected.some(p => p.id === payment.id);
          if (count && count <= this.selected.length && !isAlreadySelected) {
            forcedisable = true;
          }
        }
        if (this.poNumber && this.poNumber !== payment.po_number) {
          forcedisable = true;
        }
        if (this.currentClientConfig.payment_settings.utilization_approval_required
        && payment.approval_status !== utilizationStatus.APPROVED) {
          forcedisable = true;
        }
        const autoBillToParty = this.currentClientConfig.payment_settings &&
          this.currentClientConfig.payment_settings.auto_bill_to_party;
        if (autoBillToParty) {
          const isInvalidMovement = (this.movement === 2 && payment.movement !== this.movement) ||
          (this.movement === 1 && payment.movement !== this.movement);
          if (isInvalidMovement) {
            forcedisable = true;
          }
          if (payment.movement !== 1) {
            const isMultiDropIndentAvailable = this.selected
              .some(paymentItr => paymentItr.consignee_data.length > 1);
            if (isMultiDropIndentAvailable && this.isMultiDrop !== payment.order_reference) {
              forcedisable = true;
            } else if (!isMultiDropIndentAvailable && payment.isMultiDrop && this.selected.length > 0) {
              forcedisable = true;
            } else if (!isMultiDropIndentAvailable && !payment.isMultiDrop
              && this.selected.length > 0 && payment.consignee_data[0] &&
              payment.consignee_data[0].destination_location_id !== this.paymentDestinationDepot) {
              forcedisable = true;
            }
          }
        }
        if (this.currentClientConfig.payment_settings.restrict_multi_month_payment) {
          const multiMonthConfig = this.currentClientConfig.payment_settings && this.currentClientConfig.payment_settings.restrict_multi_month_payment;
          const date = (multiMonthConfig === MultiMonthPaymentConstants.INDENT_CREATED_DATE) ? payment.indent_created_date : payment.delivered_date;
          const currentPaymentMonth = date
            ? moment(date).month() : null;
          const firstIndentMonth = moment(this.indentDate).month();
          if (this.indentDate && (currentPaymentMonth !== firstIndentMonth)) {
            forcedisable = true;
          }
        }
        if (this.indentStatus && (this.indentStatus !== payment.status)) {
          forcedisable = true;
        }
        if (this.disabledPayments.includes(payment.id)) {
          forcedisable = true;
        }
        if (!forcedisable) {
          enabledPays.push(payment);
        }
      }
      return enabledPays;
    },
  },
  created() {
    this.loadSearchFromSession();
    if (this.$hasFeature('filter_all_legal_entity_in_rfb')) {
      const allFilter = { id: -2, name: 'ALL', value: 'All' };
      const exists = defaultLEFilter.some(filter => filter.id === allFilter.id);
      if (!exists) { defaultLEFilter.push(allFilter); }
    }
  },
  mounted() {
    const allowedIndentFilters = this.indentFilters.filter(_filter =>
      (_filter.age_filter ? !!this.paymentAgeWindow : true),
    );
    this.indentFilters = allowedIndentFilters;
    this.setDefaults();
    this.loadFilters();
    this.syncSelectedLegalEntity();
    this.$store.commit('paymentsV2/initialReset');
    this.search();
  },
  beforeRouteLeave(to, from, next) {
    this.clearInfoMessage();
    next();
  },
  methods: {
    getLegalEntity(item) {
      if (this.customLegalEntityAllowed) {
        return {
          id: `lec-${item.client_legal_entity}`,
          name: item.client_legal_entity,
          value: item.client_legal_entity,
        };
      }
      return item;
    },
    currentMovement(payment) {
      let currMovement = payment.movement;
      const parentPayment = this.getParentIndent(payment);
      if (parentPayment && parentPayment.id
         && this.currentClientConfig.payment_settings.handle_round_trip_return_as_forward
         && !this.disabledPayments.includes(parentPayment.id)) {
        currMovement = (payment.parent_indent && payment.parent_indent.movement)
         || currMovement;
      }
      return currMovement;
    },
    handleRegularLegalEntityFilter(depot) {
      let legalEntity = [];
      if (depot.legal_entity && depot.legal_entity.length) {
        const temp = [];
        legalEntity = depot.legal_entity.reduce((acc, _entity) => {
          const entity = this.getLegalEntity(_entity);
          if (!temp.includes(entity.name)) {
            acc.push(entity);
            temp.push(entity.name);
          }
          return acc;
        }, []);
      }
      this.legalEntityFilters = legalEntity && legalEntity.length
        ? this.defaultLEFilter.concat(legalEntity) : this.defaultLEFilter;
      this.setLegalEntityFilter();
      this.setPandoLegalEntityFilter();
    },
    syncSelectedLegalEntity() {
      if (!this.isLegalEntityBasedOnBillToParty) return;
      const pandoLeFilter = this.filterConstant[0]
        .find(item => item.category === this.filters.PANDO_LEGAL_ENTITY);
      const selected = pandoLeFilter && pandoLeFilter.selected;
      if (selected && selected.id !== -1 && selected.id !== -2) {
        const billToPartyFilter = this.filterConstant[0]
          .find(item => item.category === this.filters.BILL_TO_PARTY);
        const selectedBtp = billToPartyFilter && billToPartyFilter.selected;
        const leFromConfig = this.currentClientConfig.legal_entity
          && this.currentClientConfig.legal_entity.find(le => le.legal_entity_code === selected.value);
        const leFromDepot = selectedBtp && selectedBtp.legal_entity
          && selectedBtp.legal_entity.find(le => (le.value === selected.value || le.name === selected.value));
        this.$store.commit('paymentsV2/setSelectedLegalEntity', leFromConfig || leFromDepot || null);
      } else {
        this.$store.commit('paymentsV2/setSelectedLegalEntity', null);
      }
    },
    handleBillToPartyLegalEntityFilter(billToPartyDepot) {
      let legalEntity = [];
      if (billToPartyDepot && billToPartyDepot.legal_entity && billToPartyDepot.legal_entity.length) {
        const temp = [];
        legalEntity = billToPartyDepot.legal_entity.reduce((acc, _entity) => {
          const entity = this.getLegalEntity(_entity);
          if (!temp.includes(entity.name)) {
            acc.push(entity);
            temp.push(entity.name);
          }
          return acc;
        }, []);
      }
      this.legalEntityFilters = legalEntity && legalEntity.length
        ? this.defaultLEFilter.concat(legalEntity) : this.defaultLEFilter;
      this.setLegalEntityFilter();
      this.setPandoLegalEntityFilter();
    },
    updateLegalEntity(index1, index2, data, type = null) {
      if (this.filterConstant[index1][index2].category === this.filters.DEPOT) {
        if (!this.isLegalEntityBasedOnBillToParty) {
          this.handleRegularLegalEntityFilter(data);
        }
      } else if (this.filterConstant[index1][index2].category === this.filters.BILL_TO_PARTY) {
        if (this.isLegalEntityBasedOnBillToParty) {
          this.handleBillToPartyLegalEntityFilter(data);
          this.$store.commit('paymentsV2/setSelectedLegalEntity', null);
        }
      } else if (this.filterConstant[index1][index2].category === this.filters.LEGAL_ENTITY) {
        this.setPandoLegalEntityFilter(data);
        if (this.isLegalEntityBasedOnBillToParty) {
          this.$store.commit('paymentsV2/setSelectedLegalEntity', null);
        }
      } else if (this.filterConstant[index1][index2].category === this.filters.PANDO_LEGAL_ENTITY) {
        if (this.isLegalEntityBasedOnBillToParty && data && data.id !== -1 && data.id !== -2) {
          const leFromConfig = this.currentClientConfig.legal_entity
            && this.currentClientConfig.legal_entity.find(le => le.legal_entity_code === data.value);
          const billToPartyFilter = this.filterConstant[this.isLegalEntityBasedOnBillToParty ? 0 : 1]
            .find(item => item.category === this.filters.BILL_TO_PARTY);
          const selectedBtp = billToPartyFilter && billToPartyFilter.selected;
          const leFromDepot = selectedBtp && selectedBtp.legal_entity
            && selectedBtp.legal_entity.find(le => (le.value === data.value || le.name === data.value));
          const leDetails = leFromConfig || leFromDepot || null;
          this.$store.commit('paymentsV2/setSelectedLegalEntity', leDetails);
        } else if (this.isLegalEntityBasedOnBillToParty) {
          this.$store.commit('paymentsV2/setSelectedLegalEntity', null);
        }
      }
      this.filterConstant = [...this.filterConstant];
      this.updateOption(index1, index2, data, type);
    },
    setPandoLegalEntityFilter(selectedClientLe = null) {
      if (this.customLegalEntityAllowed) {
        const result = {
          list: this.defaultLEFilter,
          default: this.defaultLEFilter[0],
          selected: this.defaultLEFilter[0],
        };
        const index = this.filterConstant[0].findIndex(filter =>
          filter.category === this.filters.PANDO_LEGAL_ENTITY);
        if (selectedClientLe) {
          const defaultFilter = this.defaultLEFilter.filter(item => item.id === -1);
          const allFilter = this.defaultLEFilter.filter(item => item.id === -2);
          if (![-1, -2].includes(selectedClientLe.id)) { // not in [Default, All]
            let selectedSource = null;
            if (this.isLegalEntityBasedOnBillToParty) {
              const billToPartyFilter = this.filterConstant[this.isLegalEntityBasedOnBillToParty ? 0 : 1]
                .find(item => item.category === this.filters.BILL_TO_PARTY);
              selectedSource = (billToPartyFilter && billToPartyFilter.selected) || null;
            } else {
              const depotFilter = this.filterConstant[0]
                .find(item => item.category === this.filters.DEPOT);
              selectedSource = (depotFilter && depotFilter.selected) || null;
            }
            let firstFilter = defaultFilter;
            if (this.$hasFeature('filter_all_legal_entity_in_rfb')) {
              firstFilter = allFilter;
            }
            result.list = firstFilter.concat(
              (selectedSource && selectedSource.client_le_to_pando_le_map
              && selectedSource.client_le_to_pando_le_map[selectedClientLe.value])
              || []);
          } else {
            result.list = defaultFilter;
          }
        }
        this.pandoLegalEntityFilters = uniqBy(result.list, 'name');
        this.filterConstant[0][index].list = this.pandoLegalEntityFilters;
        this.filterConstant[0][index].default = this.pandoLegalEntityFilters[0];
        this.filterConstant[0][index].selected = this.pandoLegalEntityFilters[0];
      }
    },
    markDisabled(paymentId, isDisabled) {
      const index = this.disabledPayments.indexOf(paymentId);
      if (index === -1 && isDisabled) {
        this.disabledPayments.push(paymentId);
      }
      if (index > -1 && !isDisabled) {
        this.disabledPayments.splice(index, 1);
      }
    },
    markDisabledDiffLE(paymentId) {
      if (!this.disabledPaymentsWithDiffLE.includes(paymentId)) {
        this.disabledPaymentsWithDiffLE.push(paymentId);
      }
    },
    disableNonMatchingPayments(legalEntity) {
      this.payments.forEach((payment) => {
        if (payment.legal_entity !== legalEntity) {
          this.markDisabledDiffLE(payment.id);
        }
      });
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON = localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = Object.assign({}, this.searchedParams, sessionSearchParams);
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    checkMenuOptions() {
      return this.Menu.filter(element =>
        (element.feature ? this.$hasFeature(element.feature) : true) &&
        (element.permission ? this.$hasPermission(element.permission) : true),
      );
    },
    async downloadExcel(data) {
      try {
        const value = data;
        const filter = this.constructFilterPayload();
        if (!value && this.selectedIds) {
          filter.payment_ids = this.selectedIds;
        }
        Object.keys(filter).forEach((key) => {
          if (filter[key] === '' || filter[key] === null || filter[key] === undefined) {
            delete filter[key];
          }
        });
        const result = await this.$store.dispatch('paymentsV2/downloadExcel', filter);
        if (result && result.data === 'Success') {
          this.$infoMessage({ message: this.$getSuccess('PAYMENT_DOWNLOAD_VIA_EMAIL') });
        } else {
          this.$errorMessage({ message: this.$getErr('PAYMENT_DOWNLOAD_FAILS') });
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('PAYMENT_DOWNLOAD_FAILS') });
      }
    },
    setDefaults() {
      const depot = this.$route.query.depot;
      const depotObj = (this.depots.find(value => value.name === depot) ||
      this.otherDepots, find(value => value.name === depot)
        || (this.depots[0] || this.otherDepots[0]));
      if (this.isLegalEntityBasedOnBillToParty) {
        this.legalEntityFilters = this.defaultLEFilter;
      } else {
        const legalEntityFilter = depotObj.legal_entity ? depotObj.legal_entity.map(item => this.getLegalEntity(item)) : [];
        this.legalEntityFilters = depotObj.legal_entity ? this.defaultLEFilter.concat(legalEntityFilter) : this.defaultLEFilter;
      }
      this.pandoLegalEntityFilters = this.defaultLEFilter;
      this.defaultValues.depot = depotObj;
      [this.defaultValues.dateFilterTypes] = this.dateFilterTypes;
      [this.defaultValues.deliveryType] = this.deliveryTypes;
      [this.defaultValues.taxType] = this.taxTypes;
      [this.defaultValues.client] = this.clients;
      [this.defaultValues.indentType] = this.indentFilters;
      [this.defaultValues.statusType] = this.filteredStatusFilters;
      this.defaultValues.endDate = moment().toString();
      this.defaultValues.startDate = '';
      [this.defaultValues.legalEntity] = this.legalEntityFilters;
      [this.defaultValues.pandoLegalEntity] = this.pandoLegalEntityFilters;
    },
    constructDepotListPay(billToPartyDepot = false) {
      const group = [];
      if (this.depots.length) {
        group.push(
          {
            group_type: billToPartyDepot ? AppConstant.DepotGroupType.BILL_TO_PARTY_DEPOT :
              AppConstant.DepotGroupType.ASSOCIATED_DEPOT,
            options: this.depots,
            icon: null,
          },
        );
      }
      if (this.otherDepots.length) {
        group.push({
          group_type: AppConstant.DepotGroupType.OTHER_DEPOT,
          options: this.otherDepots,
          icon: null,
        });
      }
      return group;
    },
    constructConstantForFilter() {
      this.filterConstant = [
        [
          {
            type: 'List',
            category: this.filters.CLIENT,
            default: this.defaultValues.client,
            selected: this.defaultValues.client,
            list: this.clients,
            queryParamString: 'client_id',
            idLabel: 'id',
            optional: false,
            tlabel: 'PAY_CLIENT',
          },
          {
            type: 'GroupList',
            category: this.filters.DEPOT,
            default: this.constructDepotListPay()[0].options[0],
            selected: this.constructDepotListPay()[0].options[0],
            list: this.constructDepotListPay(),
            queryParamString: 'depot_id',
            idLabel: 'id',
            optional: false,
            search: true,
            tlabel: 'PAY_DEPOT',
            searchEnable: true,
          },
          ...(this.isLegalEntityBasedOnBillToParty && this.$hasFeature('bill_to_party_filter_in_invoice_flow') ? [{
            type: 'GroupList',
            category: this.filters.BILL_TO_PARTY,
            default: [],
            selected: [],
            list: this.constructDepotListPay(true),
            queryParamString: 'bill_to_party',
            idLabel: 'id',
            optional: false,
            search: true,
            tlabel: 'PAY_BILL_TO_PARTY',
            searchEnable: true,
          }] : []),
          {
            type: 'List',
            category: this.filters.LEGAL_ENTITY,
            default: this.defaultValues.legalEntity,
            selected: this.defaultValues.legalEntity,
            list: this.legalEntityFilters,
            queryParamString: this.customLegalEntityAllowed ? 'client_legal_entity' : 'legal_entity',
            idLabel: 'value',
            optional: true,
            search: true,
            hasPermission: this.showLegalEntity,
            tlabel: 'PAY_LEGAL_ENTITY',
          },
          {
            type: 'List',
            category: this.filters.PANDO_LEGAL_ENTITY,
            default: this.defaultValues.pandoLegalEntity,
            selected: this.defaultValues.pandoLegalEntity,
            list: this.pandoLegalEntityFilters,
            queryParamString: 'legal_entity',
            idLabel: 'value',
            optional: true,
            search: true,
            hasPermission: this.showLegalEntity && this.customLegalEntityAllowed,
            tlabel: 'PANDO_LEGAL_ENTITY',
          },
        ],
        [
          ...(!this.isLegalEntityBasedOnBillToParty && this.$hasFeature('bill_to_party_filter_in_invoice_flow') ? [{
            type: 'GroupList',
            category: this.filters.BILL_TO_PARTY,
            default: [],
            selected: [],
            list: this.constructDepotListPay(true),
            queryParamString: 'bill_to_party',
            idLabel: 'id',
            optional: false,
            search: true,
            tlabel: 'PAY_BILL_TO_PARTY',
            searchEnable: true,
          }] : []),
          {
            type: 'List',
            category: this.filters.DATE_FILTER_TYPE,
            default: this.defaultValues.dateFilterTypes,
            selected: this.defaultValues.dateFilterTypes,
            list: this.dateFilterTypes,
            queryParamString: 'date_filter_type',
            idLabel: 'value',
            optional: false,
            tlabel: 'PAY_DATE_FILTER_TYPE',
          },
          {
            type: 'Date',
            category: this.filters.DATE,
            defaultStartDate: this.defaultValues.startDate,
            defaultEndDate: this.defaultValues.endDate,
            startDate: this.defaultValues.startDate,
            endDate: this.defaultValues.endDate,
            optional: true,
            start_date_label: 'date_start',
            end_date_label: 'date_end',
            tlabel: 'PAY_DATE',
          },
          {
            type: 'List',
            category: this.filters.INDENT_TYPE,
            default: this.defaultValues.indentType,
            selected: this.defaultValues.indentType,
            list: this.indentFilters,
            queryParamString: 'filter_type',
            idLabel: 'id',
            optional: true,
            tlabel: 'PAY_INDENT_TYPE',
          },
          {
            type: 'List',
            category: this.filters.STATUS_TYPE,
            default: this.defaultValues.statusType,
            selected: this.defaultValues.statusType,
            list: this.currentClientConfig && this.currentClientConfig.payment_in_dispatch_status
            && this.currentClientConfig.payment_in_dispatch_status.enabled === true ? this.enabledPayInDispatchStatusFilters
              : this.filteredStatusFilters,
            queryParamString: 'status',
            idLabel: 'id',
            optional: true,
            tlabel: 'PAY_STATUS_TYPE',
          },
          {
            type: 'List',
            category: this.filters.DELIVERY_TYPE,
            default: this.defaultValues.deliveryType,
            selected: this.defaultValues.deliveryType,
            list: this.deliveryTypes,
            queryParamString: 'delivery_type',
            idLabel: 'id',
            optional: false,
            tlabel: 'PAY_DELIVERY_TYPE',
          },
          {
            type: 'List',
            category: this.filters.TAX,
            default: this.defaultValues.taxType,
            selected: this.defaultValues.taxType,
            list: this.taxTypes,
            queryParamString: 'taxable',
            idLabel: 'value',
            optional: true,
            tlabel: 'PAY_TAX',
          },
        ],
      ];
    },
    resetApply() {
      const depotIndex = this.filterConstant[0].findIndex(filter =>
        filter.category === this.filters.DEPOT);
      const legalEntity = this.filterConstant[0][depotIndex] && this.filterConstant[0][depotIndex].list[0] &&
        this.filterConstant[0][depotIndex].list[0].legal_entity;
      this.legalEntityFilters = legalEntity ? this.defaultLEFilter.concat(legalEntity) : this.defaultLEFilter;
      this.setLegalEntityFilter();
      this.setPandoLegalEntityFilter();
      this.resetAll();
      this.search();
    },
    setLegalEntityFilter() {
      const index = this.filterConstant[0].findIndex(filter =>
        filter.category === this.filters.LEGAL_ENTITY);
      this.filterConstant[0][index].list = this.legalEntityFilters;
      this.filterConstant[0][index].default = this.legalEntityFilters[0];
      this.filterConstant[0][index].selected = this.legalEntityFilters[0];
    },
    updateIndent(index) {
      this.index = index;
      this.loadIndentDetails();
      this.isOpenUpdate = true;
    },
    searchByParameter(query) {
      this.searchedParams = query;
      this.$store.commit('paymentsV2/setPage', 1);
      this.saveSearchToSession();
      this.loadData();
    },
    search() {
      this.applyFilters();
      const depotFilter = this.findByCategory(this.filters.DEPOT);
      this.openSlideleft = false;
      this.clearSelected();
      this.$store.commit('paymentsV2/setPage', 1);
      if (depotFilter && depotFilter.name) {
        this.$router.push({ name: 'payments', query: { depot: depotFilter.name } });
      }
      this.loadData();
    },
    openInvoicePanel() {
      this.showInvoicePanel = true;
    },
    async confirmAddPaymentToInvoice({ invoiceId, paymentIds }) {
      this.showInvoicePanel = false;
      this.addProgressStatus = null;
      this.addProgressStep = 0;
      this.addProgressError = null;
      this.addProgressDialog = true;
      await this.$nextTick();
      this.addProgressStatus = 'processing';
      try {
        const result = await this.$store.dispatch('paymentsV2/addPaymentToInvoice', {
          invoiceId,
          paymentIds,
        });
        if (!result || result.error) {
          this.addProgressError = (result && result.error) || 'Failed to queue add request.';
          this.addProgressStatus = 'failed';
          return;
        }
        this.addProgressStep = 1;
        this.pollJobStatus({
          action: 'paymentsV2/checkPaymentJobStatus',
          params: { invoiceId, redisKey: result.redisKey },
          onProcessing: (step) => { if (step != null) this.addProgressStep = step; },
          onCompleted: async (jobResult) => {
            this.addProgressStep = this.addProgressSteps.length;
            await this.$nextTick();
            this.addProgressStatus = 'completed';
            this.clearSelected();
            const orderNos = (jobResult && jobResult.addedOrderNos) || [];
            setTimeout(() => {
              this.addProgressDialog = false;
              this.$router.push({
                name: 'invoiceDetails',
                params: { id: invoiceId },
                query: orderNos.length ? { added_orders: orderNos.join(',') } : undefined,
              });
            }, 1000);
          },
          onFailed: (errMsg) => {
            this.addProgressError = errMsg || 'Failed to add payment. Please try again.';
            this.addProgressStatus = 'failed';
          },
        });
      } catch (error) {
        this.addProgressError = error.message || 'An unexpected error occurred.';
        this.addProgressStatus = 'failed';
      }
    },
    async loadData() {
      try {
        if (!this.$hasFeature('ready_for_billing')) {
          this.$router.push({ name: 'freightBill' });
        }
        this.clearInfoMessage();
        if (this.clients && this.clients.length > 0 && ((this.depots && this.depots.length > 0) ||
              (this.otherDepots && this.otherDepots.length > 0))) {
          let filter = this.constructFilterPayload();
          if (filter) {
            filter = Object.assign(filter, this.filter);
            if (this.searchedParams && Object.keys(this.searchedParams).length) {
              Object.assign(filter, { ...this.searchedParams });
            }
            const result = await this.$store.dispatch('paymentsV2/filter', filter);
            this.blockingDueToAgedInvoice = result.blockingDueToAgedInvoice;
            this.blockingDueToAgedPayments = result.blockingDueToAgedPayments;
            this.restrictActions(this.blockingDueToAgedInvoice);
            if (result.error) {
              this.$errorMessage({ message: result.error });
            }
            this.loadCheck = this.hasEmpty;
          }
        } else {
          this.$errorMessage({ message: this.$getErr('FEILDS_MISSING') });
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('LISTING_FAILS') });
      }
    },
    restrictActions(blocked) {
      const buttonIndex = this.paymentsButtonsList.findIndex(button => button.name === 'Create Invoice');
      if (blocked && !this.messageData) {
        this.messageData = this.$fixedInfoMessage({
          message: 'Please move to the invoice section and clear the aged invoices first',
          header: 'Info',
        });
      }
      this.paymentsButtonsList[buttonIndex].disabled = blocked;
    },
    clearInfoMessage() {
      if (this.messageData) {
        this.messageData.close();
        this.messageData = null;
      }
    },
    getParentIndent(payment) {
      const parentIndentId = payment && payment.parent_indent && payment.parent_indent._id;
      return (this.excludedAssociatedPayments.indexOf(parentIndentId) === -1)
        && this.payments.find(row => row.indent_id === parentIndentId);
    },
    getChildIndents(payment) {
      const childIndentIds = payment && payment.child_indent_ids && payment.child_indent_ids.filter(
        id => !this.excludedAssociatedPayments.includes(id));
      return this.payments.filter(row => childIndentIds.includes(row.indent_id));
    },
    markAssociatedIndent(payment, includeIndent) {
      const parentIndentId = payment.parent_indent && payment.parent_indent._id;
      const childIndentIds = payment && payment.child_indent_ids;
      const associatedIndentIds = [...childIndentIds, parentIndentId];
      for (let i = 0; i < associatedIndentIds.length; i += 1) {
        const associatedIndentId = associatedIndentIds[i];
        const index = this.excludedAssociatedPayments.indexOf(associatedIndentId);
        if (includeIndent && index === -1) {
          this.excludedAssociatedPayments.push(associatedIndentId);
        } else if (!includeIndent && index > -1) {
          this.excludedAssociatedPayments.splice(index, 1);
        }
      }
    },
    allowSelection(payment, status) {
      const index = this.selected.findIndex(selected => selected.id === payment.id);
      const allowSelect = ((index === -1) && status)
                          || ((index > -1) && !status);
      return !this.disabledPayments.includes(payment.id) && allowSelect;
    },
    handleSelected(payment, status) {
      const isRoundTripSeparate = this.currentClientConfig && this.currentClientConfig.payment_settings
          && this.currentClientConfig.payment_settings.handle_round_trip_return_as_forward;
      if (isRoundTripSeparate && payment.parent_indent) {
        if (!status) {
          this.markAssociatedIndent(payment, false);
        }
        const parentIndent = this.getParentIndent(payment);
        if (parentIndent && this.allowSelection(parentIndent, status)) {
          this.select(parentIndent);
        } else if (!parentIndent && status) {
          this.markAssociatedIndent(payment, true);
        }
      }
      this.select(payment);
      if ((this.$hasFeature('filter_all_legal_entity_in_rfb') || this.$hasFeature('primary_legal_entity')) && status) {
        const selectedId = payment.id;
        const currPayment = this.payments.find(payment => payment.id === selectedId);
        if (currPayment) {
          this.disableNonMatchingPayments(currPayment.legal_entity);
        }
      }
      if ((this.$hasFeature('filter_all_legal_entity_in_rfb') || this.$hasFeature('primary_legal_entity')) && !status && this.selected.length === 0) {
        this.disabledPaymentsWithDiffLE = [];
      }
      if (isRoundTripSeparate && payment.child_indent_ids && payment.child_indent_ids.length) {
        if (!status) {
          this.markAssociatedIndent(payment, false);
        }
        const childIndents = this.getChildIndents(payment);
        if (childIndents && childIndents.length) {
          for (let i = 0; i < childIndents.length; i += 1) {
            if (this.allowSelection(childIndents[i], status)) {
              this.select(childIndents[i]);
            }
          }
        } else if (status) {
          this.markAssociatedIndent(payment, true);
        }
      }
    },
    select(payment) {
      const index = this.selected.findIndex(selected => selected.id === payment.id);
      if (index === -1) {
        this.selected.push(payment);
        this._toastIfOverIndentLimit(payment.movement);
      } else {
        this.selected.splice(index, 1);
      }
      if (this.selected.length === 0) {
        this.deliveryType = null;
        this.movement = null;
        this.isSpecialRebateGateIndent = null;
        this.type = null;
        this.truck_type = null;
        this.poNumber = null;
        this.paymentDestinationDepot = null;
        this.indentDate = null;
        this.indentStatus = null;
        this.billToPartyId = null;
      } else if (this.selected.length === 1) {
        const [firstitem] = this.selected;
        this.deliveryType = firstitem.delivery_type;
        this.isSpecialRebateGateIndent = firstitem.is_special_rebate_gate_indent;
        this.movement = firstitem.movement;
        this.type = firstitem.type;
        this.truck_type = firstitem.truck_type;
        this.poNumber = firstitem.po_number;
        this.billToPartyId = firstitem.bill_to_party;
        this.paymentDestinationDepot = firstitem.consignee_data[0]
          && firstitem.consignee_data[0].destination_location_id;
        this.indentStatus = firstitem.status;
        if (this.currentClientConfig.payment_settings && this.currentClientConfig.payment_settings.restrict_multi_month_payment) {
          const multiMonthConfig = this.currentClientConfig.payment_settings.restrict_multi_month_payment;
          this.indentDate = (multiMonthConfig === MultiMonthPaymentConstants.INDENT_CREATED_DATE)
            ? payment.indent_created_date : payment.delivered_date;
        }
      }
      const multiDropIndent = this.selected.filter(row => row.consignee_data.length > 1);
      this.isMultiDrop = (multiDropIndent.length && multiDropIndent[0].order_reference) || '';
    },
    clearSelected() {
      this.selected = [];
      this.deliveryType = null;
      this.movement = null;
      this.isSpecialRebateGateIndent = null;
      this.type = null;
      this.truck_type = null;
      this.poNumber = null;
      this.paymentDestinationDepot = null;
      this.indentDate = null;
      this.indentStatus = null;
      this.disabledPaymentsWithDiffLE = [];
    },
    selectAllMethod(checked) {
      if (checked) {
        const enabledPays = this.enabledPayments;
        if (enabledPays.length) {
          this.selected = [];
        }
        const cappedPays = this._capToIndentLimit(enabledPays);
        for (let payIndex = 0; payIndex < cappedPays.length; payIndex += 1) {
          const payment = cappedPays[payIndex];
          this.select(payment);
        }
        if (cappedPays.length < enabledPays.length) {
          const bulkMovementKey = this.movementMapLowerForConfig[this.movement];
          this.$infoMessage({ message: `A maximum of ${cappedPays.length} indent${cappedPays.length === 1 ? '' : 's'} can be selected per invoice for ${bulkMovementKey}. Only the first ${cappedPays.length} indent${cappedPays.length === 1 ? '' : 's'} have been selected.` });
        }
      } else {
        this.clearSelected();
      }
    },
    async nextIndent() {
      this.index = this.index + 1;
      if (!this.hasEmpty && this.payments.length - 1 <= this.index) {
        await this.loadData();
      }
      this.loadIndentDetails();
    },
    previousIndent() {
      this.index = this.index - 1;
      this.loadIndentDetails();
    },
    async loadIndentDetails() {
      try {
        this.selectedIndentDetail = null;
        const selectedIndent = this.payments[this.index];
        const paymentId = selectedIndent.id;
        const result = await this.$store.dispatch('paymentsV2/getIndentDetails', {
          payment_ids: paymentId,
        });
        if (result && result.error) {
          this.$errorMessage({ message: result.error });
        } else if (result && result.payments) {
          this.chargeComments = result.chargeComments;
          [this.selectedIndentDetail] = result.payments;
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('LISTING_FAILS') });
      }
    },
    updateIndentDetails(data) {
      this.selectedIndentDetail = data;
    },
    addIndentDetails(data, section) {
      this.selectedIndentDetail[section].push(data);
    },
    removeIndentDetails(id, section) {
      this.selectedIndentDetail[section] = this.selectedIndentDetail[section]
        .filter(data => data.id !== id);
    },
    updatePaymentDetails(data, section) {
      // Split indents
      if (section === 'all_physical_documents_available' || section === 'lr_attachment_available') {
        this.payments.map((payment) => {
          const paymentDetail = payment;
          if (paymentDetail.order_no === this.selectedIndentDetail.order_no) {
            let value = true;
            for (let index = 0; index < paymentDetail.consignee_data.length; index += 1) {
              if (paymentDetail.consignee_data[index].destination_location_id !== this.selectedIndentDetail.consignee_data[index].destination_location_id) {
                value = false;
              }
            }
            if (value) {
              paymentDetail[section] = data;
              this.$store.commit('paymentsV2/updatePayments', paymentDetail);
            }
          }
        });
      } else {
        this.selectedIndentDetail[section] = data;
        this.$store.commit('paymentsV2/updatePayments', this.selectedIndentDetail);
      }
    },
    setGA() {
      const depot = this.findByCategory(this.filters.DEPOT) || {};
      this.$addGAEvent('Transporter - Pay', arguments[0], `Transporter - Ready for Billing:${arguments[1]}`, depot.name);
    },
    _capToIndentLimit(pays) {
      const maxIndentsConfig = this.currentClientConfig.payment_settings &&
        this.currentClientConfig.payment_settings.max_indents_for_invoice;
      if (!maxIndentsConfig || !pays.length) return pays;
      const movementKey = this.movementMapLowerForConfig[this.movement];
      const limit = movementKey && maxIndentsConfig[movementKey];
      return (limit && pays.length > limit) ? pays.slice(0, limit) : pays;
    },
    _toastIfOverIndentLimit(movement, enabledPays = []) {
      const maxIndentsConfig = this.currentClientConfig.payment_settings &&
        this.currentClientConfig.payment_settings.max_indents_for_invoice;
      if (!maxIndentsConfig) return;
      if (enabledPays.length === 0 && !movement) return;
      const movementKey = this.movementMapLowerForConfig[movement];
      const limit = movementKey && maxIndentsConfig[movementKey];
      if (limit && this.selected.length === limit) {
        this.$infoMessage({ message: `Only a max of ${limit} indent${limit === 1 ? '' : 's'} can be selected per invoice for ${movementKey}.` });
      }
    },
  },
};
</script>
